import {MarkupNodeType} from '#src/constants.js';
import TLDS_LIST_JSON from '#src/data/tlds.json' with {type: 'json'};
import {createHtmlTag, toBase64} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

const TLDS_SET = new Set(TLDS_LIST_JSON.items);

// Special TLDs
TLDS_SET.add('i2p');

const convertLinkCommon = (isMarkdown, hrefIsText) => ({context, matchStart, options, text}) => {
  if (!text) {
    return '';
  }

  options.skipType = SkipType.SkipHtml;

  if (context.isIn(matchStart.index, matchStart[0].length, SkipType.SkipHtml)) {
    return text;
  }

  if (!hrefIsText) {
    [text] = matchStart;
  }

  let url = text;

  if (!url.toLowerCase().startsWith('http', 0) && !url.toLowerCase().startsWith('ftp', 0)) {
    url = `http://${url}`;
  }

  return createHtmlTag(MarkupNodeType.Link, {
    'data-text': toBase64(text),
    'data-url': url
  }, {isMarkdown});
};

const convertProtocol = isMarkdown => ({matchStart, options}) => {
  options.skipType = SkipType.SkipHtml;

  return createHtmlTag(MarkupNodeType.Link, {
    'data-text': toBase64(matchStart.groups.text),
    'data-url': matchStart[0]
  }, {isMarkdown});
};

const convertPostLink = isMarkdown => ({context, matchStart, options}) => {
  options.skipType = SkipType.SkipHtml;

  const {boardName, postNumber} = matchStart.groups;

  return createHtmlTag(MarkupNodeType.PostLink, {
    'data-board-name': boardName || context.boardName,
    'data-post-number': Number(postNumber)
  }, {isMarkdown});
};

function checkExternalLink(info, matchs) {
  if (matchs.index > 0 && ['@', '#'].includes(info.text[matchs.index - 1])) {
    return false;
  }

  const {hostname, tld} = matchs.groups;

  return /^\d+\.\d+\.\d+\.\d+$/u.test(hostname) || (Boolean(tld) && TLDS_SET.has(tld.toLowerCase()));
}

function checkPostLink(context, [, boardName]) {
  return context.boardNames.includes(boardName);
}

export default [{
  cl: '[/url]',
  convert: convertLinkCommon(false, true),
  op: '[url]',
  priority: 1600
}, {
  check: checkExternalLink,
  cl: null,
  convert: convertLinkCommon(true, false),
  // eslint-disable-next-line no-useless-escape, max-len
  op: /(?:https?:\/\/|ftp:\/\/)?(?<hostname>[\w\p{L}.-]+\.(?<tld>(?:[\p{L}]{2,17}|i2p)\.?)|(?:(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9]))(?::\d+)?(?:[\/\w\p{L}.\-!?=+#~&%:;'",()«»\[\]]*)*\/?/ugi,
  priority: 1700
}, {
  cl: null,
  convert: convertProtocol(true),
  op: /(?:mailto|irc|news):(?<text>\S+)/giu,
  priority: 1800
}, {
  cl: null,
  convert: convertPostLink(true),
  op: />>(?<postNumber>[1-9][0-9]*)/giu,
  priority: 2200
}, {
  check: checkPostLink,
  cl: null,
  convert: convertPostLink(true),
  op: />>\/(?<boardName>[^/\s]+)\/(?<postNumber>[1-9][0-9]*)/giu,
  priority: 2300
}];
